<div class="flex flex-col w-full gap-2 shadow bg-slate-100 rounded-md text-md">
    <div id="card-name-holder" class="flex flex-col bg-ponder-light text-slate-50 rounded-t-md p-2 shadow">
        Versions
    </div>
    <div class="flex flex-col pb-1 shadow-sm">
        <table class="table-auto">
            <thead class="text-left">
                <tr>
                    <th class="pl-2">Set</th>
                    <th>Number</th>
                    <th class="pr-2">USD</th>
                </tr>
            </thead>
            <tbody class="text-sm">
                <div id="tooltip-holder" class="absolute">
                    <div #versionTooltip role="tooltip" class="absolute z-50 inline-block w-[171px] h-[240px] shadow rounded-lg left-[-181px] bg-contain invisible"></div>
                </div>
                @for (reprint of getNeighborReprints(); track reprint.item.id) {
                    <tr
                        class="group hover:bg-ponder-linkhover hover:bg-opacity-15 border-t" 
                        [ngClass]="{'bg-ponder-linkhover bg-opacity-20' : isThisCard(reprint)}"
                        (mouseenter)="onVersionHover(reprint)"
                        (mouseleave)="onVersionStopHover()"
                        (click)="onVersionClick(reprint)">
                        <td class="pl-2 cursor-pointer truncate max-w-[20ch]" [ngClass]="{ 'cursor-default' : isThisCard(reprint) }">
                            <a href="{{ getVersionUrl(reprint) }}" [attr.title]="getTooltipName(reprint.item.data!.magic!.set!.name!)">{{ reprint.item.data!.magic!.set!.name! }}</a>
                        </td>
                        <td>#{{ reprint.item.data!.magic!.setIndex }}</td>
                        <td class="pr-2" [ngClass]="{ 'border-r-2 border-ponder-link' : isCollected(reprint) }">{{ getPrice(reprint) }}</td>
                    </tr>
                }

                <tr class="group hover:bg-ponder-linkhover hover:bg-opacity-15 cursor-pointer border-t">
                    <td>
                        <button (click)="routeToAllVersions()" class="pl-4 flex flex-row gap-2">
                            <div>→</div>
                            <div>See all versions ({{ reprints?.length ?? 0 }})</div>
                        </button>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>